var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleXmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.84375C5.0957 1.84375 3.36914 2.85938 2.4043 4.48438C1.46484 6.13477 1.46484 8.14062 2.4043 9.76562C3.36914 11.416 5.0957 12.4062 7 12.4062C8.87891 12.4062 10.6055 11.416 11.5703 9.76562C12.5098 8.14062 12.5098 6.13477 11.5703 4.48438C10.6055 2.85938 8.87891 1.84375 7 1.84375ZM7 13.625C4.66406 13.625 2.53125 12.4062 1.36328 10.375C0.195312 8.36914 0.195312 5.90625 1.36328 3.875C2.53125 1.86914 4.66406 0.625 7 0.625C9.31055 0.625 11.4434 1.86914 12.6113 3.875C13.7793 5.90625 13.7793 8.36914 12.6113 10.375C11.4434 12.4062 9.31055 13.625 7 13.625ZM9.46289 5.5L9.03125 5.93164L7.83789 7.125L9.03125 8.31836L9.46289 8.75L8.625 9.61328L8.19336 9.18164L7 7.98828L5.80664 9.18164L5.375 9.61328L4.51172 8.75L4.94336 8.31836L6.13672 7.125L4.94336 5.93164L4.51172 5.5L5.375 4.66211L5.80664 5.09375L7 6.28711L8.19336 5.09375L8.625 4.66211L9.46289 5.5Z",
    fill: "#0962AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleXmark);
export default __webpack_public_path__ + "static/media/circle-xmark.17e6105dc807428748361eda40d597cc.svg";
export { ForwardRef as ReactComponent };